import { CommonModule } from '@angular/common';
import { AfterViewInit, Component, Input } from '@angular/core';
import { NgxPaginationModule, PaginationControlsComponent, PaginationControlsDirective, PaginationInstance } from 'ngx-pagination';

@Component({
    selector: 'app-paginator',
    imports: [NgxPaginationModule, CommonModule],
    templateUrl: './paginator.component.html',
    styleUrl: './paginator.component.scss'
})
export class PaginatorComponent extends PaginationControlsComponent implements AfterViewInit {

@Input('paginationData') p!: PaginationControlsDirective;

constructor() {
  super();

}
  ngAfterViewInit(): void {
 
  }




}
